import { Post } from "../app_services/ApiService";
import { Loading, AlertError, AlertInfo, AlertClose, AlertWarning } from "../app_services/AlertService";
import { ToastSucess, ToastWarning } from "../app_services/ToastService";

export const otp_request = async (form) => {
    try {
        Loading()
        let respon = await Post(`mkmedical-api/sms/otp-request`, form);
        if (respon.status !== 200) {
            AlertError();
            return;
        }

        if (respon.data.status !== '1') {
            ToastWarning(respon.data.message)
            AlertClose();
            return false
        }
        ToastSucess(respon.data.message)

        AlertClose();
        return respon.data.data
    } catch (error) {
        console.log(error)
        AlertError();
    }
};

export const otp_verify = async (form, get_main_user_data, setUserData) => {
    try {
        Loading()
        let respon = await Post(`mkmedical-api/sms/otp-verify`, form);
        if (respon.status !== 200) {
            AlertError();
            return;
        }

        if (respon.data.status !== '1') {
            ToastWarning(respon.data.message, 5000)
            AlertClose();
            return false
        }
        ToastSucess(respon.data.message)


        let res_regis = await save_map_customer_line_account(form)

        if (res_regis) {
            await get_main_user_data({ line_userid: form.LINE_TOKEN }, null, setUserData)
        }

        AlertClose();

        return true
    } catch (error) {
        console.log(error)
        AlertError();
    }
};



export const get_check_mobile_register = async (form) => {
    try {
        Loading()
        let respon = await Post(`mkmedical-api/customer/reward-customer-line-account/get-check-mobile-register`, form);
        if (respon.status !== 200) {
            AlertError();
            return;
        }
        if (respon.data.status !== '1') {
            AlertInfo(form.MOBILE, respon.data.message)
            return false
        }
        // ToastSucess(respon.data.message)

        AlertClose();
        return true
    } catch (error) {
        console.log(error)
        AlertError();
    }
};



export const save_map_customer_line_account = async (form) => {
    try {
        Loading()
        let respon = await Post(`mkmedical-api/customer/reward-customer-line-account/save-map-customer-line-account`, form);
        if (respon.status !== 200) {
            AlertError();
            return;
        }

        console.log(respon)

        if (respon.data.status !== '1') {
            AlertWarning('', respon.data.message)
            return false
        }

        // ToastSucess(respon.data.message)

        AlertClose();
        return true
    } catch (error) {
        console.log(error)
        AlertError();
    }
};

